import classNames from 'classnames';
const containerCss = "ck77nh6";
export const Container = ({
  className,
  ...props
}) => <div {...props} className={classNames(containerCss, className)} />;

// `minmax(0, 1fr)` (not bare `1fr`, which is `minmax(auto, 1fr)`) sets the track
// minimum to 0 so it never expands to a card's max-content width. Without this a
// long, un-truncated title stretches the column past the container, which breaks
// title ellipsis and prevents the row from shrinking to the small-container width.
const listContainerCss = "lq51zii";
export const ListContainer = ({
  className,
  ...props
}) => <div {...props} className={classNames(listContainerCss, className)} />;
const loadingContainerCss = "lqcli4r";
export const LoadingContainer = ({
  className,
  ...props
}) => <div {...props} className={classNames(loadingContainerCss, className)} />;

require("./styles.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");